module.exports = __webpack_public_path__ + "static/media/Uklon.3ca948d8.svg";